<template>
  <div class="personal-info">
    <van-cell title="账号" :value="usersInfo.userId"/>
    <van-cell title="姓名" :value="usersInfo.displayName"/>
    <van-cell title="性别" :value="usersInfo.genderDesc"/>
    <van-cell title="读者类型" :value="usersInfo.userGroupDesc" />
    <van-cell title="证件状态" :value="usersInfo.idStatusDesc" />
    <van-cell title="手机号码" :value="usersInfo.mobile"/>
	  <van-cell title="注册时间" :value="usersInfo.regDate"/>
	  <van-cell title="失效时间" :value="usersInfo.expireDate"/>
	  <van-cell title="所属馆" :value="reader.libName" v-if="reader"/>
	  <van-cell title="所属馆" v-else />
    <van-cell title="学院 | 单位" :value="usersInfo.dept"/>
    <van-cell title="生日" :value="usersInfo.birthday"/>
    <van-cell title="地址" :value="usersInfo.address"/>
    <van-cell title="邮箱" :value="usersInfo.email"/>
  </div>
</template>

<script>
import {defineComponent, ref, onMounted, computed} from "vue";
import {getUsersInfo} from '../api/users';
import {isNotEmpty} from '../utils/util';
import store from '@/store';

export default defineComponent({
  name: "PersonalInfo",
  setup(){
        const usersInfo = ref({});
	      const reader = computed(() => {
	          return store.state.reader.user;
	      });
        const onGetUsersInfo = () => {
            getUsersInfo()
                .then(data=> {
                    if(isNotEmpty(data)){
                        usersInfo.value = data;
                        if(usersInfo.value.regDate){
                            usersInfo.value.regDate = usersInfo.value.regDate.substring(0,10);
                        }
                        if(usersInfo.value.mobile){
                            usersInfo.value.mobile = usersInfo.value.mobile.substring(0,3) + '****' + usersInfo.value.mobile.substring(7);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        };
        onMounted(() => {
            onGetUsersInfo();
        });
        return{
            onGetUsersInfo,
            usersInfo,
            reader
        }
    },
});
</script>